import { Checkbox as CheckBoxBase, FormControlLabel } from "@mui/material";
import { CSSProperties, useState } from "react";

interface CheckBoxBasicProps {
    label: any;
    color?: CSSProperties["color"];
    disabled?: boolean;
}
export interface CheckBoxProps extends CheckBoxBasicProps {
    checked: boolean;
    onClick: (checked: boolean) => void;
}

// mui doc: https://mui.com/material-ui/react-checkbox/
export function CheckBox(props: CheckBoxProps) {
    const { checked, onClick, label, color, disabled } = props;
    return (
        <FormControlLabel
            control={
                <CheckBoxBase
                    checked={checked}
                    onChange={(e) => {
                        onClick(e.target.checked);
                    }}
                />
            }
            disabled={disabled}
            label={label}
            sx={{ color: color }}
        />
    );
}

export const useCheckBox = (props: CheckBoxBasicProps): [any, boolean] => {
    const [checked, setChecked] = useState(false);
    return [
        <CheckBox
            checked={checked}
            onClick={(b: boolean) => {
                setChecked(b);
            }}
            {...props}
        />,
        checked,
    ];
};
